import * as actions from "../actionTypes";

const initialState = {
  result: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.CREATE_VERIFY_CARD_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };

    default:
      return state;
  }
};
